import { render, staticRenderFns } from "./LoanApproval.vue?vue&type=template&id=2492c93e&scoped=true"
import script from "./LoanApproval.vue?vue&type=script&lang=js"
export * from "./LoanApproval.vue?vue&type=script&lang=js"
import style0 from "./LoanApproval.vue?vue&type=style&index=0&id=2492c93e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492c93e",
  null
  
)

export default component.exports